// Entry point → wwwroot/js/doc.js (built by `npm run build`, run from the csproj).
//
// Everything shared by the Razor pages lives here and is exposed once as window.DOC.
// Pages call DOC.openSheet / DOC.closeSheet / DOC.openLightbox / DOC.showToast /
// DOC.lockScroll / DOC.unlockScroll instead of carrying their own copies. A few legacy
// globals are kept so inline scripts written against the old site.js keep working.

import { lockScroll, unlockScroll, isScrollLocked } from './scroll-lock';
import { pushLayer, popLayer, hasLayers } from './layers';
import { addSwipeToClose } from './swipe';
import { openSheet, closeSheet, toggleSheet, isSheetOpen } from './sheet';
import { openLightbox, closeLightbox } from './lightbox';
import { showToast } from './toast';
import { initActionSheetDesktopSync } from './action-sheet-desktop';

const DOC = Object.freeze({
    lockScroll, unlockScroll, isScrollLocked,
    pushLayer, popLayer, hasLayers,
    addSwipeToClose,
    openSheet, closeSheet, toggleSheet, isSheetOpen,
    openLightbox, closeLightbox,
    showToast,
});

declare global {
    interface Window {
        DOC: typeof DOC;
        showToast: typeof showToast;
        addSwipeToClose: typeof addSwipeToClose;
        openCsLightbox: typeof openLightbox;
        closeCsLightbox: typeof closeLightbox;
    }
}

window.DOC = DOC;
// Legacy globals (site.js / site.mobile.js / Collection lightbox names).
window.showToast = showToast;
window.addSwipeToClose = addSwipeToClose;
window.openCsLightbox = openLightbox;
window.closeCsLightbox = closeLightbox;

initActionSheetDesktopSync();

export {};
